import NoDataFound from './NoDataFound';

export default NoDataFound;
